module.exports = __webpack_public_path__ + "media/images/duracion-w-203ec41d9d08c62b1709d175db036762.png";